/**
 * css-declarations — CSS 선언 직렬화 (기능 함수 — 도메인 무관, 어느 프로젝트에서나 동일).
 * 문자열 조립 금지: 속성 하나 = 객체 한 줄, false = 꺼진 줄.
 */
import type { PropertiesHyphen } from 'csstype';

/** 스타일 선언(declaration) 뭉치 — CSS 문법의 공식 단위로, `속성: 값` 한 쌍이 선언 하나다.
 *  속성 하나가 객체 한 줄. 값이 false 면 그 줄은 꺼진 것(직렬화에서 제외).
 *  키·값 타입은 csstype(React CSSProperties 의 원천, 타입 전용 0바이트)의 케밥 표기판. */
export type CssDeclarations = { [K in keyof PropertiesHyphen]?: PropertiesHyphen[K] | false };

/** 선언 뭉치 → 인라인 css 문자열. false(꺼진 줄)·undefined 는 버린다.
 *  { 'grid-row': '15/span 1', 'font-weight': false } → "grid-row:15/span 1" */
export function css(declarations: CssDeclarations): string {
  return Object.entries(declarations)
    .filter(([, value]) => value !== false && value != null)
    .map(([property, value]) => `${property}:${value}`)
    .join(';');
}

/** 규칙 뭉치 → 스타일시트 문자열. { '.pc': {...} } → ".pc{...}" */
export function stylesheet(rulesBySelector: Record<string, CssDeclarations>): string {
  return Object.entries(rulesBySelector)
    .map(([selector, declarations]) => `${selector}{${css(declarations)}}`)
    .join('\n');
}
